import { useSelector } from 'react-redux';
import { AppState } from '../store';
import { GoogleUser } from '../store/auth/types';

export const useAuthenticated = () => {
  return useSelector<AppState, GoogleUser | null>((state) => state.auth.user);
};
